<form
  [formGroup]="requestReminderForm"
  ishFormSubmit
  #form="ngForm"
  (ngSubmit)="submitForm()"
  class="form-horizontal"
  novalidate
>
  <formly-form [form]="requestReminderForm" [fields]="fields" />

  <div class="row form-group">
    <div class="offset-md-4 col-md-8">
      <button
        type="submit"
        value="PasswordReminder"
        name="passwordReminder"
        class="btn btn-primary"
        [disabled]="requestReminderForm.invalid && form.submitted"
      >
        {{ 'forgot_password.form.send.button.label' | translate }}
      </button>
    </div>
  </div>
</form>
